<template>
  <div class="preservationBox">
    <slot name="return"></slot>
    <template v-if="step.max">
      <el-button type="primary" v-if="step.now > 1" @click="$emit('preservation', 0)">上一步</el-button>               
      <el-button type="primary" @click="$emit('preservation', 1)" v-if="step.now < step.max">下一步</el-button>
      <el-button type="primary" @click="$emit('preservation', 1)" v-else>保存</el-button>
    </template>
    <template v-if="activeName != null">
      <el-button @click="$emit('nextOr')">{{
        activeName == "first" ? "下一步" : "上一步"
      }}</el-button>
      <el-button v-show="activeName == 'second'" type="primary" @click="$emit('preservation')">保存</el-button>
    </template>
    <template v-if="isSave != null">
      <el-button type="primary" @click="$emit('preservation')">{{
        isSave ? "编辑" : "保存"
      }}</el-button>
    </template>
    <template v-if="isSave == null && activeName == null && !step.max">
      <el-button type="primary" @click="$emit('preservation')">{{
        text
      }}</el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      default: () => {
        return {
          now: 1,
          max: 0,
        };
      },
    },
    activeName: {
      type: String,
      default: () => null,
    },
    isSave: {
      type: Boolean,
      default: () => null,
    },
    text: {
      type: String,
      default: "保存",
    },
  },
};
</script>

<style lang="less" scoped>
.preservationBox {
  width: calc(100% - 30px);
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  left: 15px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 0 8px 2px rgba(64, 158, 255, 0.2);
}
</style>
